// Extracted from packages/blockchain/contracts/interfaces/IAgentTrustRegistry.sol
export const AGENT_TRUST_REGISTRY_ABI = [
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: 'string', name: 'agentDidHash', type: 'string' },
      { indexed: false, internalType: 'string', name: 'agentDid', type: 'string' },
      { indexed: false, internalType: 'string', name: 'operatorDid', type: 'string' },
      { indexed: true, internalType: 'address', name: 'operator', type: 'address' },
      { indexed: false, internalType: 'uint256', name: 'timestamp', type: 'uint256' },
    ],
    name: 'AgentRegistered',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: 'string', name: 'agentDidHash', type: 'string' },
      { indexed: false, internalType: 'string', name: 'agentDid', type: 'string' },
      { indexed: false, internalType: 'uint256', name: 'timestamp', type: 'uint256' },
    ],
    name: 'AgentDecommissioned',
    type: 'event',
  },
  {
    inputs: [
      { internalType: 'string', name: 'agentDid', type: 'string' },
      { internalType: 'string', name: 'operatorDid', type: 'string' },
      { internalType: 'bytes', name: 'agentCard', type: 'bytes' },
    ],
    name: 'registerAgent',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'string', name: 'agentDid', type: 'string' }],
    name: 'getAgent',
    outputs: [
      {
        components: [
          { internalType: 'string', name: 'agentDid', type: 'string' },
          { internalType: 'string', name: 'operatorDid', type: 'string' },
          { internalType: 'bytes', name: 'agentCard', type: 'bytes' },
          { internalType: 'uint8', name: 'status', type: 'uint8' },
          { internalType: 'uint8', name: 'autonomyLevel', type: 'uint8' },
          { internalType: 'uint256', name: 'trustScore', type: 'uint256' },
          { internalType: 'uint256', name: 'totalSignals', type: 'uint256' },
          { internalType: 'address', name: 'operator', type: 'address' },
          { internalType: 'uint256', name: 'registeredAt', type: 'uint256' },
          { internalType: 'uint256', name: 'updatedAt', type: 'uint256' },
        ],
        internalType: 'struct IAgentTrustRegistry.AgentRecord',
        name: 'record',
        type: 'tuple',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'string', name: 'agentDid', type: 'string' },
      { internalType: 'int8', name: 'signal', type: 'int8' },
      { internalType: 'string', name: 'context', type: 'string' },
    ],
    name: 'submitTrustSignal',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'string', name: 'agentDid', type: 'string' },
      { internalType: 'uint8', name: 'newStatus', type: 'uint8' },
    ],
    name: 'updateAgentStatus',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'string', name: 'agentDid', type: 'string' }],
    name: 'decommissionAgent',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
] as const;
